import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { toast } from 'react-toastify';
import styles from './LandingPage.module.css';
import imageLogo from "../../assets/images/LogoBuildStart03.png";

const Header = () => {
    return (
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <img
              src={imageLogo}   // Replace with your logo image path
              alt="Build Start Logo"
              style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
            />
            BUILD START</div>
        </div>
      </header>
    );
  };
  

const UnderConstruction = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!email) {
            setError("Please enter your email address.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError("Please enter a valid email address.");
            return;
        }

        try {
            await axios.post(`${API_BASE_URL}/api/waitlist`, { email });
            setSuccess("Thanks! You have been added to our notification list.");
            setEmail('');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to submit email. Please try again.');
        }
    };

    return (
        <>
            <Header />
            <main>
                <section className={styles.hero}>
                    <div className={styles.heroContent}>
                        <h1 className={styles.heroTitleUC}>
                            BUILD START
                        </h1>
                        <p className={styles.heroSubtitleUC}>
                            Our website is currently undergoing construction.
                            We will be up and running soon. Thank you for your patience.
                        </p>
                        <p>
                            <div className={styles.divBlock}>
                                &nbsp;
                            </div>
                        </p>
                        <div className={styles.joinWrapper}>
                            <div className={styles.textBlock}>
                                Enter your email to join our waitlist
                            </div>
                        </div>
                        <div className={styles.signUpForm}>
                            <form name="wf-form-signup-form" data-name="Signup Form" id="email-form" method="get" onSubmit={handleSubmit}>
                                <input maxLength="256" name="email" data-name="Email" placeholder="Notify me" type="email" id="field" required="" value={email} onChange={(e) => setEmail(e.target.value)} />
                                <input type="submit" data-wait="Please wait..." value="Submit"/>
                            </form>
                            <div className={styles.messageContainer}>
                                {error && <div className={styles.errorLabel}>{error}</div>}
                                {success && <div className={styles.successLabel}>{success}</div>}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default UnderConstruction;
